import { FunctionComponent } from 'react';

import HtmlStyledContent from 'components/layout/HtmlStyledContent';
import LayoutContainer, { Sizes } from 'components/layout/LayoutContainer';

import StyledComponent from './styles';
import { Props } from './types';

const PublicPageJobSectionJobBlocksJobDescription: FunctionComponent<Props> = ({
    headline,
    description,
}) => {
    return (
        <StyledComponent
            className="public-page-job-section-job-blocks-job-description"
        >
            <LayoutContainer size={Sizes.Small}>
                <div
                    className="headline"
                    dangerouslySetInnerHTML={{ __html: headline }}
                />
                <div className="list">
                    <div className="list-element">
                        <HtmlStyledContent
                            className="element-content"
                            html={description}
                        />
                    </div>
                </div>
            </LayoutContainer>
        </StyledComponent>
    );
};

export default PublicPageJobSectionJobBlocksJobDescription;